export default {
  "nav.brand": "PandabuySpreadsheet",
  "nav.categories": "Categories",
  "nav.allCategories": "All Categories",
  "hero.title": "Discover the Most Powerful PandabuySpreadsheet System for Fashion & Lifestyle Shopping",
  "hero.subtitle": "A curated, data-driven spreadsheet hub helping you find, compare, and organize the best fashion picks in seconds.",
  "hero.cta.pandabuy": "Pandabuy Sheet",
  "hero.cta.buynow": "Buy It Now",
  "hero.trust": "Updated weekly · 1000+ curated items · SEO-optimized collections",
  "categories.title": "Browse Fashion Categories",
  "categories.subtitle": "Explore our comprehensive spreadsheet collections across every fashion and lifestyle category",
  "value.title": "Why PandabuySpreadsheet Is Changing Fashion Shopping",
  "value.item1.title": "Save Hours of Searching",
  "value.item1.desc": "No more endless scrolling through product listings. Our spreadsheets organize everything you need in one structured view.",
  "value.item2.title": "Compare Instantly",
  "value.item2.desc": "Side-by-side comparisons of fashion items across styles, prices, and quality — all in a clean spreadsheet format.",
  "value.item3.title": "Weekly Curated Updates",
  "value.item3.desc": "Our team updates spreadsheet lists every week with trending streetwear, sneakers, and lifestyle picks.",
  "value.item4.title": "14 Fashion Categories",
  "value.item4.desc": "From shoes and hoodies to accessories and perfumes — every fashion vertical covered in dedicated spreadsheets.",
  "social.title": "Trusted by Fashion Enthusiasts Worldwide",
  "social.metric1": "1200+",
  "social.metric1.label": "Spreadsheet Entries",
  "social.metric2": "14",
  "social.metric2.label": "Fashion Categories",
  "social.metric3": "Weekly",
  "social.metric3.label": "Curated Updates",
  "social.metric4": "Growing",
  "social.metric4.label": "Global Traffic",
  "article.title": "PandabuySpreadsheet: The Ultimate Fashion Shopping Guide",
  "article.desc": "Learn how the PandabuySpreadsheet system transforms the way fashion enthusiasts discover, compare, and organize their shopping lists. Our comprehensive guide covers everything from streetwear curation to spreadsheet optimization techniques.",
  "article.readmore": "Read Full Guide",
  "cta.title": "Start Using PandabuySpreadsheet Today",
  "cta.subtitle": "Access our complete spreadsheet database and transform your fashion shopping experience.",
  "cta.button": "Access Full Spreadsheet Database",
  "footer.copyright": "© 2026 PandabuySpreadsheet. All rights reserved.",
  "footer.disclaimer": "This site provides informational content and curated spreadsheet resources. All external product links redirect to our partner platform.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "seo.title": "PandabuySpreadsheet Ultimate Guide: How to Master Fashion Spreadsheet Shopping in 2026",
  "seo.description": "Complete guide to PandabuySpreadsheet — the revolutionary fashion shopping spreadsheet system. Learn how curated spreadsheets save time, compare products, and organize your wardrobe picks across 14 fashion categories."
}